import React, { Fragment, useContext, useEffect, useRef, useState } from 'react';
import { Link, Redirect, useHistory } from 'react-router-dom';
import { API, handleError, postRequestConfig } from './api';
import { useTranslation } from 'react-i18next';

import FormTextInput from './FormTextInput';
import { validatePassword } from './Register';
import UserSettingsContext from './UserSettingsContext';
import './form.css';


function SetPassword() {
  const { t } = useTranslation('translations');
  
  const history = useHistory();
  const { userSettings, setUserSettings } = useContext(UserSettingsContext);
  const { passwordVerificationToken } = userSettings;

  const [passwordValid, setPasswordValid] = useState(undefined);
  const [processing, setProcessing] = useState(false);
  const [error, setError] = useState(undefined);

  const active = useRef(true);
  const passwordRef = useRef(true);

  useEffect(() => {
    return () => {
      active.current = false;
    } 
  }, []);

  function getPasswordValidation(value) {
    const valid = validatePassword(value);
    setPasswordValid(valid);
    return valid ? undefined : t('Password must be at least 8 characters long.');
  }

  function processForm(event) {
    event.preventDefault();
    if (processing) {
      return;
    }
    setProcessing(true);
    fetch(`${API}/verify/password`, {
      ...postRequestConfig,
      body: `token=${
        encodeURIComponent(passwordVerificationToken)
      }&password=${
        encodeURIComponent(passwordRef.current.value)
      }`,
    })
    .then(handleError)
    .then(() => {
      if (!active.current) {
        // We have been unmounted already
        return;
      }
      setProcessing(false);
      setUserSettings({
        ...userSettings,
        passwordVerificationToken: undefined,
      });
      history.push('/set');
    })
    .catch((error) => {
      if (!active.current) {
        // We have been unmounted already
        return;
      }
      if (error && error.response && error.response.status === 409) {
        error.message = t('The confirmation code you entered is invalid or out of date. To ensure your privacy, confirmation codes are only valid for a limited time.');
        error.expired = true;
      }
      console.error(error);
      setError(error);
      setProcessing(false);
    });
  }

  if (!passwordVerificationToken) {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      <header>
        <h1>{t('Reset your password!')}</h1>
      </header>
      <main>
        <p>{t('Select a new password.')}</p>
        <form onSubmit={processForm}>
        <FormTextInput
            ref={passwordRef}
            label={t('Password')}
            id="password"
            type="password"
            name="new-password"
            defaultValue=""
            required
            title={t('Please create a unique password for this service.')}
            pattern=".{8,}"
            placeholder=""
            getValidationError={getPasswordValidation}
          />
          <input
            type="submit"
            disabled={processing || !passwordValid}
            value="OK"
          />
        </form>
        {error
          ? <p className="error">
              {error.message || JSON.stringify(error)}
              {error.expired
              ? (
                <Fragment>
                  {t('Something went wrong!')} <Link to="/reset">{t('Please retry resetting the password.')}</Link>.
                </Fragment>
              )
              : undefined
              }
            </p>
          : undefined
        }
      </main>
    </Fragment>
  );
}

export default SetPassword;
